import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  maintenanceWarning: {
    position: 'sticky',
    height: 30,
    lineHeight: '30px',
    zIndex: 9999,
    background: props =>
      props.isReady ? theme.palette.error.main : theme.palette.warning.main,
  },
  maintenanceBanner: {
    zIndex: 9999,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: `linear-gradient(
			90deg,
			${theme.palette.primary.dark} 0%,
			${theme.palette.primary.light} 100%
		);`,
    '& img': {
      height: 90,
    },
  },
  warningIcon: {
    height: 16,
    top: 2,
  },
}));
